<template>
  <div class='landing'>
    <div>
      <img class='logo' src="@/assets/images/logo.png" alt="" height="85">     
      <img src="@/assets/images/title.svg" alt="" class="title">      
      <div class='welcome' v-if="$store.state.repId !== ''">
        <h1 v-if="$store.state.repPurl === false">Welcome, {{$store.state.client.first}}.</h1>
        <p v-if="booked">Your visit to Titans House has been booked!</p>
        <p v-else class="message">Your Titans House Experience Starts Now</p>        
      </div>
      <slot></slot>      
    </div>    
  </div>
</template>

<script>
export default {
  name:'Landing',
  props : {
    booked:Boolean
  }
}
</script>

<style lang="scss" scoped>
.message {
  color: #FFF;
font-size: 17px;
font-weight: 400;
line-height: 1.47;
}
.title {
  margin-left:-100px;
}
.logo {
  margin-bottom:60px;
  max-width: 90vw;
  object-fit: contain;
  object-position: bottom left;
  position: fixed;
  top:10px;
  left:10px;
}
.title {
  font-size: 2.375rem;
  text-transform: uppercase;
  color: var(--white);
  margin-top:45px;
}
h1, p {
  margin:5px 0;
  color: var(--white);
  font-size:2.563rem;
  font-weight: 300;
  line-height: 0.9122;
  max-width: 490px;    
  text-transform: uppercase;  
}
h1 {    
  font-weight: 600;
  margin-bottom: 27px;  
}
.welcome {  
  padding-bottom: 30px;    
}
.landing {
  flex-grow: 1;
  display: grid;
  place-items: center;
  justify-content: start;
  position: relative;
  background-image: url("~@/assets/images/welcome.jpg");
  background-size: cover;
  background-position: bottom center;
  box-sizing: border-box;
  text-align: left;
  padding:1rem;
  overflow: hidden;
  @media (min-width:730px) {
    padding:100px;
    
  }
  @media (min-width:1100px) {
    padding:200px;
    
  }
  > div {    
    position: relative;
  }  
}
</style>